module.exports = __webpack_public_path__ + "img/logo.e2d7b1e2.jpg";